export default {
  filterOptions: {
    searchByLabel: (input, option) => option.children.toLowerCase().includes(input.toLowerCase()),
  },
};
